export enum EquipmentEnterprise{
  VELSIS = "Velsis",
  PUMATRONIX = "Pumatronix",
  DAHUA = "Dahua"
}
